export default "__VITE_ASSET__cce879a6__"